import { z } from "zod";

export const getOrderByNumber = {
  input: z.object({ orderNumber: z.string(), email: z.string() }),
  output: z.object({ id: z.string(), orderDate: z.date() }),
};
